import { FC, lazy } from 'react'

import { Route, Routes } from 'react-router-dom'

import { APP } from 'src/Configs/App'
import { initiateSpotifyAuth } from 'src/Utils/spotifyAuth'
import { PreReleaseRedirect } from 'src/Router/PreReleaseRedirect'
import SignUp from 'src/Containers/SignUp/SignUp'
import ForgotPassword from 'src/Containers/ForgotPasswordPage'
import ResetPassword from 'src/Containers/ResetPassword'
import ExpiredLinkPage from 'src/Pages/Public/ExpiredLinkPage'
import InternalServerError from 'src/Containers/ui/InternalServerError'
import Registration from 'src/Containers/Registration'
import ReferralLinkNotExist from 'src/Containers/ReferralLinkNotExist/index'
import LogIn from 'src/Containers/LogIn/Login'
import { SignUpRoleSelect } from 'src/Containers/SignUp/SignUpRoleSelect'
import { ChoosePlatformNoAuthPage } from 'src/Pages/Artist/CreateCampaignPage/NoAuthPages/ChoosePlatformNoAuthPage'
import { SearchSpotifyTrackNoAuth } from 'src/Pages/Artist/CreateCampaignPage/NoAuthPages/SearchSpotifyTrackNoAuth'
import { SelectedTrackNoAuth } from 'src/Pages/Artist/CreateCampaignPage/NoAuthPages/SelectedTrackNoAuth'
import { ArtistRegisterPage } from 'src/Pages/Artist/CreateCampaignPage/NoAuthPages/ArtistRegisterPage'
import { SearchTikTokTrackNoAuth } from 'src/Pages/Artist/CreateCampaignPage/NoAuthPages/SearchTikTokTrackNoAuth'
import { ArtistRegisterPageWithoutTrack } from 'src/Pages/Artist/CreateCampaignPage/NoAuthPages/ArtistRegisterPageWithoutTrack'
import { CreateAdsNoAuth } from 'src/Pages/Artist/CreateCampaignPage/NoAuthPages/CreateAdsNoAuth'
import { SearchResourceAdsNoAuth } from 'src/Pages/Artist/CreateCampaignPage/NoAuthPages/SearchResourceAdsNoAuth'
import { ArtistRegisterPageMetaAds } from 'src/Pages/Artist/CreateCampaignPage/NoAuthPages/ArtistRegisterPageMetaAds'
import { ChooseReleaseTypeNoAuthPage } from 'src/Pages/Artist/CreateCampaignPage/NoAuthPages/ChooseReleaseTypeNoAuthPage'
import { PreReleaseTrackDetailsNoAuth } from 'src/Pages/Artist/CreateCampaignPage/NoAuthPages/PreReleaseTrackDetailsNoAuth'
import { ArtistRegisterPagePreRelease } from 'src/Pages/Artist/CreateCampaignPage/NoAuthPages/ArtistRegisterPagePreRelease'

export enum PublicRoutesEnum {
  Root = '/',
  Login = '/login',
  SignUpChooseRole = '/signup',
  SignUpCurator = '/signup-curator',
  ForgotUserPassword = '/forgot-password',
  ResetUserPassword = '/reset-password',
  UserErrors = '/errors',
  InternalError = '/internal-server-error',
  CreateCampaign = '/create',
  CreateSpotifyCampaign = '/create/spotify',
  CreateSpotifyCampaignReleaseType = '/create/spotify/release-type',
  CreatePreReleaseTrackDetails = '/create/spotify/track-details',
  CreateTikTokCampaign = '/create/tiktok',
  CreateAdsCampaign = '/create/ads',
  SignUpArtist = '/signup-artist',
  SignUpCreator = '/signup-creator',
  ReferralNotExist = '/referral-link-not-exist',
  Spotify = '/spotify',
}
const MetaLanding = lazy(() => import('src/Pages/Public/MetaLanding'))

export const PublicComponentsNewUI: FC = () => (
  <Routes>
    <Route Component={MetaLanding} path={'/metaLanding/track/:trackId'} />

    <Route Component={LogIn} path={PublicRoutesEnum.Root} />

    <Route Component={LogIn} path={PublicRoutesEnum.Login} />
    <Route
      Component={SignUpRoleSelect}
      path={PublicRoutesEnum.SignUpChooseRole}
    />
    <Route Component={SignUp} path={PublicRoutesEnum.SignUpCurator} />
    <Route
      Component={ForgotPassword}
      path={PublicRoutesEnum.ForgotUserPassword}
    />

    <Route
      Component={ResetPassword}
      path={`${PublicRoutesEnum.ResetUserPassword}/:uuid`}
    />
    <Route Component={ExpiredLinkPage} path={PublicRoutesEnum.UserErrors} />
    <Route
      Component={InternalServerError}
      path={PublicRoutesEnum.InternalError}
    />
    <Route
      Component={ChoosePlatformNoAuthPage}
      path={PublicRoutesEnum.CreateCampaign}
    />
    <Route
      Component={SearchSpotifyTrackNoAuth}
      path={PublicRoutesEnum.CreateSpotifyCampaign}
    />
    <Route
      element={
        APP.PRE_RELEASE_CAMPAIGNS_ENABLED ? (
          <ChooseReleaseTypeNoAuthPage />
        ) : (
          <PreReleaseRedirect to={PublicRoutesEnum.CreateSpotifyCampaign} />
        )
      }
      path={PublicRoutesEnum.CreateSpotifyCampaignReleaseType}
    />
    <Route
      element={
        APP.PRE_RELEASE_CAMPAIGNS_ENABLED ? (
          <PreReleaseTrackDetailsNoAuth />
        ) : (
          <PreReleaseRedirect to={PublicRoutesEnum.CreateSpotifyCampaign} />
        )
      }
      path={PublicRoutesEnum.CreatePreReleaseTrackDetails}
    />
    <Route
      element={
        APP.PRE_RELEASE_CAMPAIGNS_ENABLED ? (
          <ArtistRegisterPagePreRelease />
        ) : (
          <PreReleaseRedirect to={PublicRoutesEnum.CreateSpotifyCampaign} />
        )
      }
      path={`${PublicRoutesEnum.CreatePreReleaseTrackDetails}${PublicRoutesEnum.SignUpArtist}`}
    />
    <Route
      Component={SearchTikTokTrackNoAuth}
      path={PublicRoutesEnum.CreateTikTokCampaign}
    />
    <Route
      Component={CreateAdsNoAuth}
      path={PublicRoutesEnum.CreateAdsCampaign}
    />
    <Route
      Component={SearchResourceAdsNoAuth}
      path={`${PublicRoutesEnum.CreateAdsCampaign}/:strategy`}
    />
    <Route
      Component={ArtistRegisterPageMetaAds}
      path={`${PublicRoutesEnum.CreateAdsCampaign}/:strategy/:resourceId${PublicRoutesEnum.SignUpArtist}`}
    />
    <Route
      Component={SelectedTrackNoAuth}
      path={`${PublicRoutesEnum.CreateCampaign}/:platform/:trackId`}
    />
    <Route
      Component={ArtistRegisterPage}
      path={`${PublicRoutesEnum.CreateCampaign}/:platform/:trackId${PublicRoutesEnum.SignUpArtist}`}
    />
    <Route
      Component={ArtistRegisterPageWithoutTrack}
      path={`${PublicRoutesEnum.CreateCampaign}/:platform${PublicRoutesEnum.SignUpArtist}`}
    />
    <Route Component={Registration} path={PublicRoutesEnum.SignUpCreator} />
    <Route
      Component={ReferralLinkNotExist}
      path={PublicRoutesEnum.ReferralNotExist}
    />
    <Route
      Component={() => {
        initiateSpotifyAuth({ isSignUp: true })
        return null
      }}
      path={PublicRoutesEnum.Spotify}
    />
    <Route Component={LogIn} path='*' />
  </Routes>
)
